import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";

const AIChatbotUI = ({ text }) => {
    const [displayedText, setDisplayedText] = useState("");

    useEffect(() => {
        let currentIndex = 0;
        const intervalId = setInterval(() => {
            if (currentIndex < text.length) {
                const randomIncrement = Math.floor(Math.random() * 5) + 2;
                setDisplayedText(text.slice(0, currentIndex + randomIncrement));
                currentIndex += randomIncrement;
            } else {
                clearInterval(intervalId);
            }
        }, 20);

        return () => clearInterval(intervalId);
    }, [text]);

    return (
        <div className="flex items-start mt-4">
            <img src="/image/logo.svg" alt="AI Avatar" className="w-7 h-7 mx-1 rounded-full" />
            <div className="p-1 rounded-lg flex-1">
                <ReactMarkdown>{displayedText}</ReactMarkdown>
            </div>
        </div>
    );
};

export default AIChatbotUI;
